import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authApi } from "../api/auth";

export default function ForgotPasswordPage() {
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await authApi.forgotPassword(email);
    } finally {
      setDone(true);
      setSubmitting(false);
    }
  }

  return (
    <div style={shell}>
      <div style={card}>
        <h1 style={{ margin: 0, color: "#0b3a6f", fontSize: 24 }}>{t("forgot.title")}</h1>

        {done ? (
          <>
            <p style={{ color: "#6b7280", fontSize: 14, lineHeight: 1.6 }}>
              {t("forgot.sent")}
            </p>
            <Link to="/login" style={{ color: "#0b3a6f", fontSize: 14 }}>
              {t("forgot.back")}
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <p style={{ color: "#6b7280", fontSize: 14, margin: 0 }}>
              {t("forgot.intro")}
            </p>
            <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 14 }}>
              <span>{t("login.email")}</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={input}
              />
            </label>
            <button type="submit" disabled={submitting} style={btn}>
              {submitting ? t("forgot.submitting") : t("forgot.submit")}
            </button>
            <Link to="/login" style={{ color: "#0b3a6f", fontSize: 14, textAlign: "center" }}>
              {t("forgot.back")}
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}

const shell: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#f4f6f8",
  padding: 16,
};
const card: React.CSSProperties = {
  width: "100%",
  maxWidth: 400,
  background: "#fff",
  padding: 32,
  borderRadius: 12,
  boxShadow: "0 1px 3px rgba(0,0,0,.08)",
  display: "flex",
  flexDirection: "column",
  gap: 16,
};
const input: React.CSSProperties = {
  padding: "10px 12px",
  borderRadius: 6,
  border: "1px solid #d1d5db",
  fontSize: 15,
};
const btn: React.CSSProperties = {
  padding: "12px 16px",
  background: "#0b3a6f",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
};
